import { TStaffMember, mapStaffMemberFromGQL } from "./staff-member-model";

export type TMatter = {
  matterId: string;
  matterTypeName?: string;
  client?: string;
  isLead?: boolean;
  status?: string;
  dateOpened: Date;
  description?: string;
  matterNumber?: string;
  personResponsible?: TStaffMember | null;
  personAssisting?: TStaffMember | null;
};

// eslint-disable-next-line -- unless we want to generate types from the schema
export const mapMatterFromGQL = (graphQLMatter: any): TMatter | null => {
  if (!graphQLMatter) {
    return null;
  }

  const {
    id,
    matterType,
    status,
    isLead,
    matterNumber,
    clients,
    description,
    attorneyResponsible,
    personAssisting,
    dateOpened,
    notFound,
  } = graphQLMatter;

  let matterTypeName;

  if (matterType) {
    matterTypeName = matterType.name;
  }

  if (notFound && notFound === true) {
    return null;
  }

  if (!id || id === null) {
    return null;
  }

  const clientDisplay = (clients || []).map((c: { name: string }) => c.name || "").join(" - ");

  let attorneyStaffMember: TStaffMember | null = null;

  if (attorneyResponsible) {
    attorneyStaffMember = mapStaffMemberFromGQL(attorneyResponsible);
  }

  let personAssistingStaffMember: TStaffMember | null = null;

  if (personAssisting) {
    personAssistingStaffMember = mapStaffMemberFromGQL(personAssisting);
  }

  const matter: TMatter = {
    isLead,
    status,
    matterNumber,
    description,
    matterTypeName,
    matterId: id,
    client: clientDisplay,
    personResponsible: attorneyStaffMember,
    personAssisting: personAssistingStaffMember,
    dateOpened: dateOpened ? new Date(dateOpened) : new Date(),
  };

  return matter;
};
